
export interface ConfirmDialogOptions {
  title: string;
  message: string;
  confirmText?: string;
  confirmStatus?: string;
  cancelText?: string;
  translateParams?: any;
}

const DEFAULT_CONFIRM_DIALOG_OPTIONS = {
  title: ('are_you_sure_title'),
  message: ('are_you_sure_message'),
  confirmText: ('ok'),
  confirmStatus: 'primary',
  cancelText: ('cancel'),
  translateParams: null
};

export function createConfirmDialogOptions(options: Partial<ConfirmDialogOptions>): ConfirmDialogOptions {
  return { ...DEFAULT_CONFIRM_DIALOG_OPTIONS, ...options };
}
